import { render } from "./CustomCheckbox.vue?vue&type=template&id=7c726b92"
import script from "./CustomCheckbox.vue?vue&type=script&lang=js"
export * from "./CustomCheckbox.vue?vue&type=script&lang=js"

import "./CustomCheckbox.vue?vue&type=style&index=0&id=7c726b92&lang=scss"
script.render = render

export default script